import { atom } from 'jotai';

import { dynamicFilterMessages } from '@core/Services/Search/FilterPanel.messages';

export type DynamicFilterMessages = Record<keyof typeof dynamicFilterMessages, string>;
const defaultMessageObject: DynamicFilterMessages = Object.keys(dynamicFilterMessages).reduce(
  (acc, key) => {
    acc[key as keyof DynamicFilterMessages] =
      dynamicFilterMessages[key as keyof typeof dynamicFilterMessages].defaultMessage;
    return acc;
  },
  {} as DynamicFilterMessages,
);
export const dynamicFilterMessagesAtom = atom<DynamicFilterMessages>(defaultMessageObject);
